import PriceClass from '../PriceClass';
import { ServiceDiscountTypes } from '@clients/AuthApi';
import {
    type CabinClassRequest,
    type UserLevelRange,
} from '@clients/FlightApi';

type Service = {
    id: number;
    title: string;
    price: number;
    description: string;
    unitTitle?: string;
    needDescription?: boolean;
    image?: string;
    discount: number;
    levelRange?: UserLevelRange;
    flightClass?: CabinClassRequest;
};
export default class SuggestionService {
    id: number;
    title: string;
    preDiscountPrice: number;
    netDiscount: number;
    description: string;
    unitTitle: string;
    needDescription?: boolean;
    image: string;
    levelRange?: UserLevelRange;
    flightClass?: CabinClassRequest;

    get prePriceDiscountPercent() {
        return useAuthStore().customDiscounts.SuggestedService;
    }

    constructor({
        id,
        title,
        price,
        description,
        unitTitle,
        needDescription,
        image,
        discount,
        levelRange,
        flightClass,
    }: Service) {
        this.id = id;
        this.title = title;
        this.preDiscountPrice = price;
        this.description = description;
        this.unitTitle = unitTitle || 'تعداد';
        this.needDescription = needDescription;
        this.image = image || '/img/suggested-service/fallback.png';
        this.netDiscount = discount;
        this.levelRange = levelRange;
        this.flightClass = flightClass;
    }

    get price() {
        return this.prePriceDiscountPercent
            ? PriceClass.calculatePreDiscountPrice(
                  this.preDiscountPrice - this.netDiscount,
                  ServiceDiscountTypes.SuggestedService
              )
            : this.preDiscountPrice;
    }

    get discount() {
        return this.prePriceDiscountPercent
            ? this.preDiscountPrice - this.price
            : this.netDiscount;
    }
}

export interface SelectedSuggestionServices {
    service: SuggestionService;
    count: number;
    description?: string;
}
